import { render, staticRenderFns } from "./ProductTree.vue?vue&type=template&id=498411d9&scoped=true&"
import script from "./ProductTree.vue?vue&type=script&lang=js&"
export * from "./ProductTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductTree.vue?vue&type=style&index=0&id=498411d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498411d9",
  null
  
)

export default component.exports